import { selector } from 'recoil';

import type { ClientDocumentsFilters } from './clientDocumentsFilter';
import { clientDocumentsFiltersState } from './clientDocumentsFilter';

export const cleanDocumentsFiltersState = selector({
  key: 'cleanDocumentsFilters',
  get: ({ get }) => {
    const currentFilters = get(clientDocumentsFiltersState);

    // Clean the filters and return a new copy with everything null
    const cleanedFilters: ClientDocumentsFilters = {};
    Object.keys(currentFilters || {}).forEach((key) => {
      cleanedFilters[key] = null;
    });

    return cleanedFilters;
  },
});
